import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import numeral from 'numeral';
import _includes from 'lodash/includes';
import _isNumber from 'lodash/isNumber';
import _isString from 'lodash/isString';
import _mapValues from 'lodash/mapValues';
import _map from 'lodash/map';
import _isArray from 'lodash/isArray';
import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _curry from 'lodash/curry';
import _isFunction from 'lodash/isFunction';
import _differenceBy from 'lodash/differenceBy';
import _difference from 'lodash/difference';
import _pick from 'lodash/pick';
import _keyBy from 'lodash/keyBy';
import _isEqual from 'lodash/isEqual';
import _property from 'lodash/property';
import _reduce from 'lodash/reduce';
import _toString from 'lodash/toString';
import _size from 'lodash/size';
import _replace from 'lodash/replace';
import _join from 'lodash/join';
import _indexOf from 'lodash/indexOf';
import _isEmpty from 'lodash/isEmpty';
import _flatten from 'lodash/flatten';
import _startCase from 'lodash/startCase';
import _camelCase from 'lodash/camelCase';
import _merge from 'lodash/merge';
import _round from 'lodash/round';
import _toNumber from 'lodash/toNumber';
import _fill from 'lodash/fill';
import _forEach from 'lodash/forEach';
import _set from 'lodash/set';
import _union from 'lodash/union';
import _keys from 'lodash/keys';
import _trim from 'lodash/trim';
import _split from 'lodash/split';
import _filter from 'lodash/filter';
import qs from 'query-string';
import { produce } from 'immer';
import canUseDOM from '../can-use-dom';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from '../app.constants';
import { OS_TYPES, BUILD_ENVS, DEFAULT_KEY_FOR_GLOBAL_TEKION_DATA, MULTIPLIER_VS_DISTANCE_FORMAT, DISTANCE_FORMAT_TYPE, EQUALITY_VS_COMPARATOR } from '../constants/general';
import Money from './money';
export var getLeafNodes = function getLeafNodes(node, _ref) {
  var childKey = _ref.childKey;
  if (_isNil(node)) return null;
  var children = node[childKey];
  if (_isEmpty(children)) return node;

  var childValues = _map(children, function (child) {
    return getLeafNodes(child, {
      childKey: childKey
    });
  });

  return _flatten(childValues);
};
export var currentModuleMethodGetter = _curry(function (currentModuleMethodMap, params, currentModule) {
  var funcToBeExec = currentModuleMethodMap[currentModule];

  if (_isFunction(funcToBeExec)) {
    return funcToBeExec(params);
  }

  return undefined;
});
export var tget = function tget(object, path, defaultValue) {
  var result = _get(object, path, defaultValue);

  return _isNil(result) ? defaultValue : result;
};
export var tcompact = function tcompact(array) {
  return _filter(array, function (element) {
    return !!element || element === 0;
  });
};
export var getFilterOptions = function getFilterOptions(data, labelGetter, valueGetter) {
  return _map(data, function (element) {
    return {
      label: labelGetter(element),
      value: valueGetter(element)
    };
  });
};
export var getValidPrice = function getValidPrice(price) {
  if (_isNumber(price) && price > 0) return price;
  return 0;
};
export function formatPrice(value) {
  var result = value === undefined ? '' : numeral(value).format('0,0.00');
  return result;
}
export function parsePrice(value) {
  var result = !value ? undefined : parseFloat(value);
  return result;
}
export var addPrices = function addPrices(prices) {
  return (prices || EMPTY_ARRAY).reduce(function (total, price) {
    return Money.add(total, getNumber(price));
  }, 0);
};
export var isEmptyStringOrUndefined = function isEmptyStringOrUndefined(value) {
  if (value === '' || value === null || value === undefined) {
    return true;
  }

  return false;
};
export var generateRandomNumber = function generateRandomNumber() {
  var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  return Math.floor(Math.random() * upperLimit);
};
export var getFallbackUrl = function getFallbackUrl(type) {
  switch (type) {
    case 'image':
      return 'https://invalid.url.com';

    default:
      return '';
  }
};
export var trim = function trim(value) {
  if (!value) return '';

  if (_isString(value)) {
    return value.trim();
  }

  return value;
};
export function boolToNumber(value) {
  return Number(value);
}
export var parseExtraOptions = function parseExtraOptions(obj) {
  var normalizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (value) {
    return value;
  };
  return _mapValues(obj, function (val) {
    if (!_isArray(val)) return _castArray(normalizer(val));
    return normalizer(val);
  });
};
export var parseBackExtraOptions = function parseBackExtraOptions() {
  var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return _reduce(extra, function (acc, value, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, JSON.parse(value)));
  }, {});
};
export var getBoundingClientObj = function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
};
export var downloadFile = function downloadFile(url, fileName, openNewTab) {
  var link = document.createElement('a');
  link.style = 'display: none';
  link.href = url;
  link.setAttribute('download', fileName);
  if (openNewTab) link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
  link.parentElement.removeChild(link);
};
export var uuid = function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0; // eslint-disable-line

    var v = c == 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line

    return v.toString(16);
  });
};
export var getItemsWithKey = function getItemsWithKey(items) {
  return _map(items, function (item) {
    return _isString(item) ? {
      value: item,
      key: uuid()
    } : _objectSpread(_objectSpread({}, item), {}, {
      key: uuid()
    });
  });
};
export var changeRoute = function changeRoute(appName, path) {
  var basePath = window.location.origin;
  window.location = "".concat(basePath, "/").concat(appName, "/").concat(path);
};
export var isValidZipCode = function isValidZipCode(zipcode) {
  return zipcode.length === 5 || zipcode.length === 6;
};
export var formatZipCode = function formatZipCode(zipcode) {
  return zipcode.length > 5 ? "".concat(zipcode.slice(0, 5), "-").concat(zipcode.slice(5)) : zipcode;
};
export var isNewOption = function isNewOption(option) {
  return _get(option, '__isNew__');
};

var getEntriesToBeCreated = function getEntriesToBeCreated(newValues, oldValues, _ref2) {
  var uniqueIdKeyGetter = _ref2.uniqueIdKeyGetter;
  return _differenceBy(newValues, oldValues, uniqueIdKeyGetter);
};

var getEntriesToBeDeleted = function getEntriesToBeDeleted(newValues, oldValues, _ref3) {
  var uniqueIdKeyGetter = _ref3.uniqueIdKeyGetter;
  return _differenceBy(oldValues, newValues, uniqueIdKeyGetter);
};

var getEntriesToBeEdited = function getEntriesToBeEdited(newValues, oldValues, _ref4) {
  var keysToBeChecked = _ref4.keysToBeChecked,
      uniqueId = _ref4.uniqueId;

  var newValuesMap = _keyBy(newValues, uniqueId);

  var oldValuesMap = _keyBy(oldValues, uniqueId);

  return _reduce(oldValuesMap, function (acc, oldValue, key) {
    var newValue = newValuesMap[key];
    if (_isNil(newValue)) return acc;

    var newValueToBeConsidered = _pick(newValue, keysToBeChecked);

    var oldValueToBeConsidered = _pick(oldValue, keysToBeChecked);

    if (!_isEqual(oldValueToBeConsidered, newValueToBeConsidered)) {
      acc.push(newValue);
    }

    return acc;
  }, []);
};

export var getCRUDPayload = function getCRUDPayload(newValues, oldValues) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT,
      _ref5$keysToBeChecked = _ref5.keysToBeChecked,
      keysToBeChecked = _ref5$keysToBeChecked === void 0 ? EMPTY_ARRAY : _ref5$keysToBeChecked,
      _ref5$uniqueId = _ref5.uniqueId,
      uniqueId = _ref5$uniqueId === void 0 ? 'id' : _ref5$uniqueId,
      _ref5$uniqueIdKeyGett = _ref5.uniqueIdKeyGetter,
      uniqueIdKeyGetter = _ref5$uniqueIdKeyGett === void 0 ? _property(uniqueId) : _ref5$uniqueIdKeyGett;

  var entriesToBeCreated = getEntriesToBeCreated(newValues, oldValues, {
    uniqueIdKeyGetter: uniqueIdKeyGetter
  });
  var entriesToBeUpdated = getEntriesToBeEdited(newValues, oldValues, {
    keysToBeChecked: keysToBeChecked,
    uniqueId: uniqueId
  });

  var entriesToBeDeleted = _map(getEntriesToBeDeleted(newValues, oldValues, {
    uniqueIdKeyGetter: uniqueIdKeyGetter
  }), uniqueId);

  return {
    entriesToBeCreated: entriesToBeCreated,
    entriesToBeUpdated: entriesToBeUpdated,
    entriesToBeDeleted: entriesToBeDeleted
  };
};
export var getQueryParams = function getQueryParams(props) {
  return qs.parse(_get(props, 'location.search'));
};
export var getQueryParamsFromUrl = function getQueryParamsFromUrl(url, options) {
  return qs.parseUrl(url, options);
};
export var getQueryString = function getQueryString(params) {
  return qs.stringify(params);
};
export var getDataURI = function getDataURI(data) {
  return "data:application/pdf;base64,".concat(data);
};
/**
 * @name maskData
 * @description make the sensitive and show the in the form of  ****1234
 * @param  {string | number} value , value to be masked
 * @param  {number} charsToShow, unmasked characters at the end of the output string
 * @param  {string} replaceBy, char to show as the masked char
 */

export var maskData = function maskData(value) {
  var charsToShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  var replaceBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '*';

  var str = _toString(value);

  var length = _size(str);

  if (length <= charsToShow) return _replace(str, /./g, replaceBy);

  var maskedStr = _replace(str.substring(0, length - charsToShow), /./g, replaceBy);

  var unmaskedStr = str.substring(length - charsToShow, length);
  return "".concat(maskedStr).concat(unmaskedStr);
};
export var jsxToString = function jsxToString(element) {
  if (!element) return EMPTY_STRING;
  if (_isString(element)) return element;
  if (_isNumber(element)) return _toString(element);
  if (_isArray(element)) return _join(_map(element, function (subElement) {
    return jsxToString(subElement);
  }), EMPTY_STRING);
  if (_isFunction(element)) return jsxToString(element());
  if (element.props && element.props.children) return jsxToString(element.props.children);
  return EMPTY_STRING;
};
export var getSystemUser = function getSystemUser() {
  return {
    firstName: 'System',
    lastName: 'User',
    id: '-1'
  };
};
export var removeItemFromArray = function removeItemFromArray(actionButtons, MENU_ITEM) {
  var index = _indexOf(actionButtons, MENU_ITEM);

  actionButtons.splice(index, 1);
  return actionButtons;
}; // 1: for all versions of Windows
// 2: for all versions of Macintosh OS
// 3: for all versions of Linux
// 4: for all other UNIX flavors
// null: indicates failure to detect the OS

export var getOS = function getOS() {
  var OS = null;
  if (navigator.appVersion.indexOf('Win') !== -1) OS = OS_TYPES.WINDOWS;else if (navigator.appVersion.indexOf('Mac') !== -1) OS = OS_TYPES.MAC_OS;else if (navigator.appVersion.indexOf('Linux') !== -1) OS = OS_TYPES.LINUX;else if (navigator.appVersion.indexOf('X11') !== -1) OS = OS_TYPES.UNIX;
  return OS;
};
export var getBuildEnv = function getBuildEnv() {
  var buildEnv = process.env.BUILD_ENV;
  if (!buildEnv || !BUILD_ENVS[buildEnv]) return BUILD_ENVS.dev;
  return buildEnv;
};
export var isBuildEnvProdORPreProd = function isBuildEnvProdORPreProd() {
  var buildEnv = process.env.BUILD_ENV;
  var isProd = [BUILD_ENVS.prod, BUILD_ENVS.preprod];

  if (_includes(isProd, buildEnv)) {
    return true;
  }

  return false;
};
export var injectValuesToDOM = function injectValuesToDOM(values) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_KEY_FOR_GLOBAL_TEKION_DATA;
  if (!canUseDOM) return;
  window[key] = _objectSpread(_objectSpread({}, window[key] || EMPTY_OBJECT), values);
};
export function getNumber(stringData) {
  var result = Number(stringData);
  return !result || isNaN(result) ? 0 : result; //eslint-disable-line
}
export var merge = function merge(src, target) {
  return produce(src, function (draft) {
    return _merge(draft, target);
  });
};
export var getStringInCamelCase = function getStringInCamelCase(str) {
  return _startCase(_camelCase(str));
};
export var formatDistance = function formatDistance(value) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DISTANCE_FORMAT_TYPE.MILES;
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return _round(value * MULTIPLIER_VS_DISTANCE_FORMAT[type], precision);
};
export var getPercentage = function getPercentage(numerator, denominator) {
  return denominator ? _toNumber(numerator) / _toNumber(denominator) * 100 : 0;
};
export var isValueNil = function isValueNil(value) {
  return _isNil(value) || value === '';
};
export var getDistanceUnitAbbreviated = function getDistanceUnitAbbreviated(distanceUnit) {
  if (distanceUnit === DISTANCE_FORMAT_TYPE.KMS) return __('km');
  return __('mi');
};
export var getEqualityComparator = function getEqualityComparator(equality) {
  return EQUALITY_VS_COMPARATOR[equality] || EQUALITY_VS_COMPARATOR.DEFAULT;
};
/**
 * This function is to call function with arguments in ordering wise
 * @param {*} funcToExec
 * @param {*} totalArguments - total number of arguments to passed
 * @param {*} indexesToFill - indexes at which arguments need to be passed
 * @param {*} argsToFill - arguments to be passed for the indexes
 * @returns
 */

export var executeWithArguments = function executeWithArguments(_ref6) {
  var funcToExec = _ref6.funcToExec,
      totalArguments = _ref6.totalArguments,
      indexesToFill = _ref6.indexesToFill,
      argsToFill = _ref6.argsToFill;

  var args = _fill(Array(totalArguments), undefined);

  _forEach(indexesToFill, function (indexToFill, index) {
    return _set(args, indexToFill, argsToFill[index]);
  });

  return funcToExec.apply(void 0, _toConsumableArray(args));
};
export var getSelectInputOptions = function getSelectInputOptions(_ref7) {
  var _ref7$values = _ref7.values,
      values = _ref7$values === void 0 ? EMPTY_ARRAY : _ref7$values,
      _ref7$valueVsLabel = _ref7.valueVsLabel,
      valueVsLabel = _ref7$valueVsLabel === void 0 ? EMPTY_OBJECT : _ref7$valueVsLabel,
      _ref7$getLabel = _ref7.getLabel,
      getLabel = _ref7$getLabel === void 0 ? _startCase : _ref7$getLabel,
      _ref7$valueVsGetLabel = _ref7.valueVsGetLabel,
      valueVsGetLabel = _ref7$valueVsGetLabel === void 0 ? EMPTY_OBJECT : _ref7$valueVsGetLabel;

  var allValues = _union(values, _keys(valueVsLabel), _keys(valueVsGetLabel));

  return _map(allValues, function (value) {
    var labelGetter = valueVsGetLabel[value] || getLabel;
    return {
      label: valueVsLabel[value] || labelGetter(value),
      value: value
    };
  });
};
export var getFormattedTextWithoutSpecialCharacters = function getFormattedTextWithoutSpecialCharacters(name) {
  return _trim(_replace(name, /[:]/g, ' '));
};
export var filterUniqueValues = function filterUniqueValues(list, value) {
  return list.filter(function (item) {
    if (item.id !== value.id) return true;
    return false;
  });
};
export var queryStringParse = function queryStringParse(string) {
  var parsed = {};
  var stringVal = string;

  if (stringVal !== EMPTY_STRING) {
    stringVal = stringVal.substring(stringVal.indexOf('?') + 1);

    var p1 = _split(stringVal, '&');

    _map(p1, function (value) {
      var params = _split(value, '='); // eslint-disable-next-line prefer-destructuring


      parsed[params[0]] = params[1];
    });
  }

  return parsed;
};
/**
 * @name moveInArray
 * @description util function to move element in an array
 * @param array - list to update
 * @param { from, to } - source and destination indices
 * @returns updatedArray
 */

export var moveInArray = function moveInArray(array, _ref8) {
  var from = _ref8.from,
      to = _ref8.to;

  var updatedArray = _toConsumableArray(array);

  var elementToMove = updatedArray[from];
  updatedArray.splice(from, 1);
  updatedArray.splice(to, 0, elementToMove);
  return updatedArray;
};
export var areSomeElementsMissing = function areSomeElementsMissing(prevCollection, currentCollection) {
  return !_isEmpty(_difference(prevCollection, currentCollection));
};
export var updateValueInArray = function updateValueInArray(array, indexToUpdate, valueToUpdate) {
  var updatedArray = _toConsumableArray(array);

  _set(updatedArray, indexToUpdate, valueToUpdate);

  return updatedArray;
};
export var isJSON = function isJSON(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};
export var genericActionHandlerAdapter = function genericActionHandlerAdapter(actionHandler) {
  return function (arg1, arg2) {
    var getState = _get(arg1, 'getState') || _get(arg2, 'getState');

    var setState = _get(arg1, 'setState') || _get(arg2, 'setState');

    var params = _get(arg1, 'payload') || _get(arg1, 'params') || _get(arg2, 'params');

    return actionHandler(_objectSpread(_objectSpread(_objectSpread({}, arg1 || EMPTY_OBJECT), arg2 || EMPTY_OBJECT), {}, {
      getState: getState,
      setState: setState,
      params: params
    }));
  };
};
export var replaceSpecialChars = function replaceSpecialChars(str) {
  var replaceBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_STRING;
  return _replace(str, /[^a-z0-9A-Z_-]/g, replaceBy);
};
export var cloneInstance = function cloneInstance(original) {
  return Object.assign(Object.create(Object.getPrototypeOf(original)), original);
};
var tekSemVerSeperator = /[.,-]/;
export var compareSemver = function compareSemver(versionA, versionB) {
  var versionAParts = _split(versionA, tekSemVerSeperator);

  var versionBParts = _split(versionB, tekSemVerSeperator);

  var highestVersionPartsLength = Math.max(_size(versionAParts), _size(versionBParts));

  for (var i = 0; i < highestVersionPartsLength; i += 1) {
    var versionAPart = _toNumber(versionAParts[i] || 0);

    var versionBPart = _toNumber(versionBParts[i] || 0);

    if (versionAPart > versionBPart) return 1;
    if (versionBPart > versionAPart) return -1;
  }

  return 0;
};
export var tError = function tError(message, type) {
  var error = new Error(message);
  error.type = type;
  return error;
};
export var mapWithUniqAndCompact = function mapWithUniqAndCompact(items, mapper) {
  var _ref9 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT,
      _ref9$unique = _ref9.unique,
      unique = _ref9$unique === void 0 ? true : _ref9$unique,
      _ref9$compact = _ref9.compact,
      compact = _ref9$compact === void 0 ? true : _ref9$compact;

  return _reduce(items, function (acc, item) {
    var mappedItem = mapper(item);

    if (unique) {
      var isMappedItemAlreadyPresent = _includes(acc, mappedItem);

      if (isMappedItemAlreadyPresent) {
        return acc;
      }
    }

    if (compact && _isNil(mappedItem)) {
      return acc;
    }

    return [].concat(_toConsumableArray(acc), [mappedItem]);
  }, []);
};